export default __webpack_public_path__ + "static/media/sophia_gray_wihitebackground.bc5ada4b.jpg";